import { defineMessage } from 'react-intl';
export enum ErrorCode {
  REQUESTER_NOT_USER = 'REQUESTER_NOT_USER',
  USER_NOT_FOUND = 'USER_NOT_FOUND',
  PROXY_USER_NOT_FOUND = 'PROXY_USER_NOT_FOUND',
  PROXY_USER_INACTIVE = 'PROXY_USER_INACTIVE',
  PROXY_USER_NOT_TM = 'PROXY_USER_NOT_TM',
  PROXY_USER_SAME_AS_TM = 'PROXY_USER_SAME_AS_TM',
  PROXY_USER_NOT_FROM_SAME_COMPANY = 'PROXY_USER_NOT_FROM_SAME_COMPANY',
  ERROR = 'ERROR',
}

export const ErrorCodeTranslationIDMapping = {
  REQUESTER_NOT_USER: 'cs_perfportal_add_proxy_error_code_requester_not_user',
  USER_NOT_FOUND: 'cs_perfportal_add_proxy_error_code_proxy_user_not_found',
  PROXY_USER_NOT_FOUND:
    'cs_perfportal_add_proxy_error_code_proxy_user_not_found',
  PROXY_USER_INACTIVE: 'cs_perfportal_add_proxy_error_code_proxy_user_inactive',
  PROXY_USER_NOT_TM: 'cs_perfportal_add_proxy_error_code_proxy_user_not_tm',
  PROXY_USER_SAME_AS_TM:
    'cs_perfportal_add_proxy_error_code_requester_cannot_be_same_as_proxy',
  PROXY_USER_NOT_FROM_SAME_COMPANY:
    'cs_perfportal_add_proxy_error_code_proxy_user_not_from_same_company',
  ERROR: 'cs_perfportal_somethingWentWrong',
};

export interface ErrorCodeTranslationID {
  cs_perfportal_add_proxy_error_code_requester_not_user: string;
  cs_perfportal_add_proxy_error_code_proxy_user_not_found: string;
  cs_perfportal_add_proxy_error_code_proxy_user_inactive: string;
  cs_perfportal_add_proxy_error_code_proxy_user_not_tm: string;
  cs_perfportal_add_proxy_error_code_requester_cannot_be_same_as_proxy: string;
  cs_perfportal_add_proxy_error_code_proxy_user_not_from_same_company: string;
  cs_perfportal_somethingWentWrong: string;
}

export const ErrorCodeTranslationDefaultMapping = {
  cs_perfportal_add_proxy_error_code_requester_not_user: 'Action not permitted',
  cs_perfportal_add_proxy_error_code_proxy_user_not_found: '{alias} not found',
  cs_perfportal_add_proxy_error_code_proxy_user_inactive: '{alias} is inactive',
  cs_perfportal_add_proxy_error_code_proxy_user_not_tm: '{alias} is not a TM',
  cs_perfportal_add_proxy_error_code_requester_cannot_be_same_as_proxy:
    'Action not permitted',
  cs_perfportal_add_proxy_error_code_proxy_user_not_from_same_company:
    '{alias} is not from same company',
  cs_perfportal_somethingWentWrong: 'Something went wrong!',
};

export const localizeErrorCode = (messageCode: ErrorCode) => {
  const translationID = ErrorCodeTranslationIDMapping[messageCode];
  const translatedDefaultMessage =
    ErrorCodeTranslationDefaultMapping[
      translationID as keyof ErrorCodeTranslationID
    ];

  const message = defineMessage({
    id: `${translationID}`,
    defaultMessage: `${translatedDefaultMessage}`,
  });

  return message;
};
